<template>
  <div>
    <div v-if="loading" class="dw-loading">
      <b-spinner small></b-spinner> Loading...
    </div>
    <div v-else-if="loadError" class="dw-empty">Could not load support tickets.</div>
    <div v-else-if="!recentTickets.length" class="dw-empty">No support tickets yet.</div>
    <div v-else class="dw-table-wrap">
      <table class="dw-table">
        <thead>
          <tr>
            <th>Subject</th>
            <th>Type</th>
            <th>Status</th>
            <th>Created</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="ticket in recentTickets" :key="ticket.id" @click="goToTicket(ticket.id)">
            <!-- a subject rarely fits a quarter of a half-width card, so the
                 cell ellipsises; the title puts the whole thing one hover
                 away rather than making the row a dead end. -->
            <td :title="ticket.subject || ''">{{ ticket.subject || '(no subject)' }}</td>
            <td><span class="dw-chip" :class="ticket.priorityChip">{{ ticket.priorityLabel }}</span></td>
            <td>{{ ticket.statusLabel }}</td>
            <td>{{ ticket.createdLabel }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { search_support_tickets } from '../../networking/apis'

const MAX_ROWS = 5

// matches support_ticket_list.vue's priority (really "ticket type") and
// status option labels/tag colors, trimmed to a single chip class per type.
const PRIORITY_TAGS = {
  question: { label: 'Question', chip: 'dw-chip-neutral' },
  minor: { label: 'Minor Bug', chip: 'dw-chip-warning' },
  urgent: { label: 'Major Bug', chip: 'dw-chip-danger' },
  enhancement: { label: 'Enhancement', chip: 'dw-chip-neutral' },
  feature: { label: 'Feature', chip: 'dw-chip-success' },
}

const STATUS_LABELS = {
  open: 'Open',
  active: 'Active',
  review: 'Under Review',
  new: 'New',
  queued: 'Queued',
  progress: 'In Progress',
  waiting: 'Waiting On Customer',
  approved: 'Customer Approved',
  testing: 'Customer Testing',
  blocked: 'Blocked',
  cancelled: 'Cancelled',
  completed: 'Completed',
}

export default {
  name: 'widget_support_tickets',
  props: {
    tenant: { type: String, required: true },
  },
  data() {
    return {
      loading: true,
      loadError: false,
      tickets: [],
    }
  },
  computed: {
    recentTickets() {
      return [...this.tickets]
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
        .slice(0, MAX_ROWS)
        .map(item => {
          const tag = PRIORITY_TAGS[item.priority] || { label: item.priority || 'Ticket', chip: 'dw-chip-neutral' }
          return {
            id: item.id,
            subject: item.subject,
            priorityLabel: tag.label,
            priorityChip: tag.chip,
            statusLabel: STATUS_LABELS[item.ticket_status] || item.ticket_status || '—',
            createdLabel: item.created_at ? moment(item.created_at).format('MM/DD') : '—',
          }
        })
    },
  },
  created() {
    this.load()
  },
  methods: {
    goToTicket(id) {
      this.$router.push({ name: 'help_center', query: { tab: 'support', ticket_id: id } }).catch(() => {})
    },
    async load() {
      this.loading = true
      this.loadError = false
      try {
        const { value: { data = [] } } = await search_support_tickets(
          this.tenant, '', '', '', '', '',
          moment().subtract(1, 'year').format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD'),
          ''
        )
        this.tickets = data || []
      } catch (e) {
        this.loadError = true
      }
      this.loading = false
    },
  },
}
</script>
